import EntitiesPage from '../pages/entities-page.vue'
import NewEntitiesPage from '../pages/new-entities-page.vue'
export default [
  {
    component: EntitiesPage,
    name: 'admin.entities',
    path: '/:slug/admin/entities',
  },
  {
    component: NewEntitiesPage,
    name: 'admin.all-entities',
    path: '/:slug/admin/all-entities',
  },
  {
    component: NewEntitiesPage,
    name: 'admin.funds-in-progress',
    path: '/:slug/admin/funds-in-progress',
  },
  {
    component: NewEntitiesPage,
    name: 'admin.spv-in-progress',
    path: '/:slug/admin/spv-in-progress',
  },
]
